import FonteModel from "./FonteModel";
import LookUpModel from "./LookUpModel";

export default class CanaliModel extends LookUpModel {
    public readonly source: FonteModel = new FonteModel({});

    constructor(data: Partial<CanaliModel>) {
        super(data);

        this.update(data);
    }
}
